import React from 'react';
import { Link } from 'react-router-dom';
import './PageWayfinding.css';

const PageWayfinding = ({ showTools = false }) => (
  <nav className="page-wayfinding" aria-label="Навигация по разделам">
    <Link className="page-wayfinding-row" to="/">
      <span className="page-wayfinding-arrow" aria-hidden="true">
        ←
      </span>
      На главную
    </Link>
    {showTools ? (
      <Link className="page-wayfinding-row page-wayfinding-row--child" to="/tools">
        Инструменты
      </Link>
    ) : null}
  </nav>
);

export default PageWayfinding;
